document.body.addEventListener("click", (event) => {
  let target;
  if (target = event.target.closest(".color-swatch")) {
    var swatchColor = document.querySelector(`#${target.getAttribute('for')}`).value;
    var shortDescriptionAll = document.querySelectorAll(
      ".product-short-description",
    );
    var defaultDescription = document.querySelector(".default-description");
    var variantDescription = document.querySelector(
      '.custom-variant-description[data-color="' + swatchColor + '"]',
    );
    if (variantDescription) {
      shortDescriptionAll.forEach(function (description) {
        description.style.display = "none";
      });
      variantDescription.style.display = "block";
    } else {
      shortDescriptionAll.forEach(function (description) {
        description.style.display = "none";
      });
      defaultDescription.style.display = "block";
    }
  }
});
